<micro-lookup domain="domain" obj="countries" url="/countries" [key]="countryId" [link]="false"></micro-lookup>
